<app-leitor-side-tools
  class="leitor-content-side-tools"
></app-leitor-side-tools>
